export const FETCH_CHAT_MACROS = {
  cacheTime: 1000 * 60 * 15,
  staleTime: 1000 * 60 * 15,
};
